module.exports = __webpack_public_path__ + "img/architecture01.1fe1499c.jpg";